import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const API_URL_NEW = process.env.REACT_APP_API_CONNECT

export const inquiryApi = createApi({
  reducerPath: 'inquiryApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_URL_NEW}/`,
  }),

  tagTypes: ['Inquiry'],
  refetchOnMountOrArgChange: 1,
  endpoints: (builder) => ({

    createInquiries: builder.mutation({
      query: (data) => {
        return {
          url: `api/inquiries`,
          method: 'POST',
          body: data,
          headers: {
            'X-Country-Code': data.country,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Inquiry'],
    }),

 

  }),

})

export const { useCreateInquiriesMutation } = inquiryApi